import '@fontsource-variable/sn-pro'
import '@fontsource/cascadia-mono/latin-400.css'
import './styles.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { ErrorBoundary } from './ErrorBoundary'
import { installBrandIcons } from './design/brand'
import { ThemeProvider } from './design/theme'

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root')

installBrandIcons(document)

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </StrictMode>
)
